import type { FC } from "react";
import { Image, Button } from "react-bootstrap";

import { Lightbox } from "components/Lightbox";

interface Props {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
}

// Nadpis je pod ilustrací, takže zůstává v těle a jen pojmenuje dialog. [TD-344]
export const PracticeConfirmationModal: FC<Props> = ({ show, onHide, onConfirm }) => (
  <Lightbox show={show} onHide={onHide} className="mt-5" bodyTitleId="practice-confirmation-title">
    <div className="d-flex justify-content-center">
      <Image src={"/images/pozor-na-tohle.svg"} width={120} loading={"eager"} />
    </div>
    <div className="text-center mb-5">
      {/* Velikost drží `.fs-18`, ať se sjednocením na `h2` (globálně 17 px) nezmění
          vzhled — původní odstavec s `.h3` měl 18 px ($h3-font-size). [TD-344] */}
      <h2 id="practice-confirmation-title" className="fs-18">
        Úlohy, které spouštíš, budou tzv. „nanečisto“
      </h2>
      <p>
        Tady si procvičíš konkrétní téma, které ti nejde. Ale procvičování nanečisto se nepočítá do denního tréninku a
        nesplníš tak řadu.
      </p>
      <p>Trénink pro splnění řady spustíš jedině z dashabordu na úvodní stránce.</p>
    </div>
    <Button className="w-100" onClick={onConfirm}>
      Ok, pokračovat
    </Button>
  </Lightbox>
);
